document.addEventListener('DOMContentLoaded', function () {
    if (window.customer) {
        // Use direct API call (after CORS headers are added to data.kasaustralia.com.au)
        const apiUrl = `https://kas-cin7-shopify-sync.jackieochan.workers.dev/kas/points.php?email=${encodeURIComponent(window.customer.email)}&customer_id=${encodeURIComponent(window.customer.id)}`;
        
        fetch(apiUrl, {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        }).then(function (response) {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        }).then(function (data) {
            const pointBalance = data && data.pointBalance !== undefined ? data.pointBalance : null;
            updatePointsUI(pointBalance);
        }).catch(function (error) {
            console.error('API call failed:', error);
            // Show dash when no data available
            updatePointsUI(null);
        });
        
        function updatePointsUI(pointBalance) {
            const emails = document.querySelectorAll('.c-account-dropdown__loyalty-email');
            const points = document.querySelectorAll('.c-account-dropdown__loyalty__points');
            const greetings = document.querySelectorAll('.c-account-dropdown__greeting');
            const loyaltyRembembered = document.querySelectorAll('.c-account-dropdown__loyalty-remember');
            const pointAwards = document.querySelectorAll('.c-account-dropdown__loyalty__text');

            points.forEach(function (element) {
                if (pointBalance === null || pointBalance === undefined) {
                    element.textContent = '-';
                } else {
                    element.textContent = pointBalance + ' points';
                }
            });

            // Also update KAS rewards system if available
            if (window.KASRewards && window.KASRewards.updatePoints) {
                window.KASRewards.updatePoints(pointBalance);
            } else {
                // Manually update drawer elements if KAS rewards system is not available
                const drawerPoints = document.querySelector('[data-kas-rewards-points]');
                if (drawerPoints) {
                    if (pointBalance === null || pointBalance === undefined) {
                        drawerPoints.textContent = '-';
                    } else {
                        drawerPoints.textContent = pointBalance;
                    }
                }
                
                // Update swell point balance elements
                const swellPointBalances = document.querySelectorAll('.swell-point-balance');
                swellPointBalances.forEach(function(element) {
                    if (pointBalance === null || pointBalance === undefined) {
                        element.textContent = '-';
                    } else {
                        element.textContent = pointBalance + ' points';
                    }
                });
            }

            pointAwards.forEach(function (element) {
                if (pointBalance === null || pointBalance === undefined) {
                    element.querySelector('p').textContent = 'Points unavailable';
                } else {
                    const pointReachDiscount = 100 - (pointBalance % 100);
                    const reachDiscount = Math.ceil(pointBalance / 100);
                    
                    element.querySelector('p').textContent = `You are ${pointReachDiscount} points away from a $${reachDiscount * 10} discount`;
                }
            });
            

            if (window.customerRemembered) {
                emails.forEach(function (element) {
                    element.textContent = window.customer.email;
                });

                greetings.forEach(function (element) {
                    element.textContent = `Hi, ${window.customer.firstName} ${window.customer.lastName}`;
                });

                loyaltyRembembered.forEach(function (element) {
                    element.classList.remove('hidden');
                });
            }
        }
    } else {
        document.querySelectorAll('.c-account-dropdown__loyalty.hidden').forEach(function (element) {
            element.classList.remove('hidden');
        });
    }
});